
export default class ApiHelper {
    static appSettings;  
}

export const API_ACTION_LOGIN = "User/Login";
export const API_GET_INFO_BY_EMAIL = "User/InfoByEmail";
export const API_ACTION_UPLOADEXCEL = "ExcelMapping/UploadExcel";
export const API_ACTION_CONVERTSELECTED = "ExcelMapping/ConvertSelected";
export const API_ACTION_GETPROCESSEDEXCELFILES = "ExcelMapping/GetProcessedExcelFiles";
export const API_ACTION_GETFILEDATA = "Registrations/GetRegistrations";
export const API_ACTION_DELETETRANSFORMEDEXCEL = "ExcelMapping/DeleteTransformedExcel";
export const API_ACTION_CREATEMAPPING = "ExcelToMatisMapper/CreateMapping";
export const API_ACTION_LOGINNODERED = "login";

export const API_ACTION_CONVERT2EXCELNODERED = "Registrations/Convert2excel";

//export const API_ACTION_CONVERT2EXCELNODERED = "convert2excel";
export const API_ACTION_GETALLREGISTRATIONS = "Registrations/GetRegistrations"
export const API_ACTION_DELETEREGISTRATION = "Registrations/DeleteRegistration"
export const API_ACTION_SAVEREGISTRATION = "Registrations/saveRegistration"
export const API_ACTION_GETALLMATERIALS = "Registrations/GetMaterials"
export const API_ACTION_GETALLWASTESTREAMS = "Registrations/GetWastestreams"
export const API_ACTION_GETALLUNITOFMEASUREMENTS = "Registrations/GetUnitOfMeasurements"
export const API_ACTION_GETALLORIGINS = "Registrations/GetOrigins"
export const API_ACTION_GETALLDESTINATIONS = "Registrations/GetDestinations"
export const API_ACTION_GETALLCOLLECTIONMETHODS = "Registrations/GetCollectionMethods"

export const API_ACTION_GETUSER = "Registrations/GetUserById"
export const API_ACTION_GETSYSTEMPARAMETERS = "SystemParameter/GetSystemParameters"


export const ComposeUri = (action) => {
    return ApiHelper.appSettings.DATATRANSFORM_API_BASE_URL + action;
}

export const ComposeNodeRedUri = (action) => {
    return ApiHelper.appSettings.DATATRANSFORM_NODE_RED_URL + action;
}

